module.exports = __webpack_public_path__ + "img/rar.8f314041.svg";